
import { PlusOutlined } from '@ant-design/icons-vue'
import { computed, ref, toRaw } from 'vue'
import SongModal from './SongModal.vue'
import { ColorMap } from './config'

export default {
  emits: ['updateList'],
  components: {
    PlusOutlined,
    SongModal
  },
  props: {
    list: {
      type: Array,
      default: () => { return [] }
    },
    formIsEdit: {
      type: Boolean,
      default: () => { return false }
    }
  },
  setup (props, { emit }) {
    // 列表数据
    const listComputed = computed(() => props.list)
    const formIsEditComputed = computed(() => props.formIsEdit)

    const current = ref({})
    const visible = ref(false)
    const isEdit = ref(false)

    const labelCol = { span: 5 }
    const wrapperCol = { span: 17 }
    const currentIndex = ref(-1)

    const handleRemoveItem = item => {
      const list = ref(toRaw(listComputed.value))
      const index = list.value.indexOf(item)
      if (index !== -1) {
        list.value.splice(index, 1)
      }
      emit('updateList', list)
    }

    const handleEditItem = (item, index) => {
      visible.value = true
      current.value = item
      currentIndex.value = index
      isEdit.value = true
    }

    const handleAddConfig = () => {
      isEdit.value = false
      current.value = {}
      visible.value = true
      currentIndex.value = -1
    }

    const handleModalCancel = () => {
      current.value = {}
      visible.value = false
      currentIndex.value = -1
    }

    const handleModalOk = info => {
      const list = ref(toRaw(listComputed.value))
      list.value.push(info)
      emit('updateList', list.value)
    }

    const handleModalEditOk = info => {
      const list = ref(toRaw(listComputed.value))
      list.value[currentIndex.value] = info
      emit('updateList', list.value)
    }

    return {
      current,
      visible,
      isEdit,
      labelCol,
      wrapperCol,
      formIsEditComputed,
      listComputed,
      ColorMap,
      handleAddConfig,
      handleRemoveItem,
      handleModalCancel,
      handleModalOk,
      handleEditItem,
      handleModalEditOk
    }
  }
}
